<div class="container" [@fadeInOut]="state">
  <div class="title-container">
    <!-- <h6>{{ subtitle.split(' ')[0] }} {{ subtitle.split(' ')[1] }}<span [style]="{ 'font-style': 'italic' }"> {{ subtitle.split(' ')[2] }}</span></h6>
    <input
      #input
      (blur)="deleteTrim(input.value, input)"
      (input)="getText(input.value)"
      [(ngModel)]="lod_subtitle"
      type="text"
    /> -->
    <!-- <p-button
      *ngIf="!first"
      icon="pi pi-trash"
      (onClick)="deleteView()"
      [rounded]="true"
      severity="danger"
      [style]="{ 'border-radius': '50%', width: '35px', height: '35px' }"
    ></p-button> -->
  </div>
  <hr />
  <div class="container">
    <app-question-block #firstComponent [first]="true" [order]="1"></app-question-block>

    <ng-container #view> </ng-container>
  </div>

  <br />
  <div class="title-container center">
    <p-button
      (onClick)="generate()"
      label="Agregar pregunta"
      icon="pi pi-plus"
      [rounded]="true"
      severity="info"
      [style]="{ 'border-radius': '40px', 'margin-top': '10px' }"
    ></p-button>
  </div>
</div>
